"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./Progress.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Progress component allows to show progress indicator
 *
 * When a `ref` prop is provided, it will be forwarded to the root element. Any
 * other properties supplied will be provided to the root element (ie, the `as`
 * prop value). This includes all appropriate HTML attributes or aria tags.
 */
const Progress = /*#__PURE__*/React.forwardRef(({
  max = 100,
  min = 0,
  value = 0,
  variant = 'primary',
  borderRadius,
  progressColor,
  progressBg,
  isVertical,
  ...otherProps
}, ref) => {
  const percentageValue = Math.max(Math.min((value - min) * 100 / (max - min), 100), 0);
  const progressBarStyle = isVertical ? {
    height: "".concat(percentageValue, "%")
  } : {
    width: "".concat(percentageValue, "%")
  };
  return (0, _pragma.createFelaElement)(_.View, _extends({
    css: css.root,
    cssProps: {
      variant,
      borderRadius,
      progressBg,
      isVertical
    },
    ref: ref,
    role: "progressbar",
    "aria-valuemax": max,
    "aria-valuemin": min,
    "aria-valuenow": value
  }, otherProps), (0, _pragma.createFelaElement)("div", {
    css: css.wrapper,
    cssProps: {
      variant,
      isVertical
    },
    style: progressBarStyle
  }, (0, _pragma.createFelaElement)("div", {
    css: css.progressBar,
    cssProps: {
      variant,
      progressColor
    }
  }), variant !== 'primary' && (0, _pragma.createFelaElement)("div", {
    css: css.indicator,
    cssProps: {
      variant,
      isVertical
    }
  })));
});
Progress.displayName = 'Progress';
var _default = Progress;
exports.default = _default;
//# sourceMappingURL=Progress.js.map